<template>
  <section class="item-card">
    <div class="card-head">
      <img class="card-image" :src="itemData.listUrl" alt="" />
      <a>
        <img
          v-if="itemData.lightIcon"
          class="card-logo"
          :src="itemData.lightIcon"
          alt=""
        />
        <span v-else class="card-logo">{{ itemData.name }}</span>
      </a>
    </div>
    <div class="card-body">
      <p v-html="decodeURIComponent(itemData.intro)"></p>
    </div>
    <div class="btn">
      <a class="explore" @click="toDetail(itemData.id)">阅读更多</a>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      default: () => ({
        id: 1,
        imageUrl: '',
        logoUrl: '',
        text: ''
      })
    }
  },
  data() {
    return {}
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        name: 'StoryDetail',
        query: { id: id }
      })
    }
  }
}
</script>

<style scoped lang="less">
.item-card {
  background-color: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
  min-width: 360px;
  max-height: 505px;
  height: 500px;
  display: flex;
  flex-direction: column;
  .card-head {
    width: 360px;
    height: 300px;
    position: relative;
    background-color: #000000;
    overflow: hidden;
    .card-image {
      width: 100%;
      height: 300px;
      object-fit: cover;
      object-position: center;
      opacity: 0.65;
      transition: all 1.5s ease-in-out;
    }
    a {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .card-logo {
      width: 210px;
      filter: invert(1);
      font-size: 40px;
      transition: all 0.5s ease-in-out;
    }
    &:hover {
      .card-image {
        transform: scale(1.04);
        opacity: 1;
      }
      .card-logo {
        transform: scale(1.1);
        opacity: 0;
      }
    }
  }
  .card-body {
    flex-grow: 1;
    padding: 25px 70px 0 30px;
  }
  .btn {
    padding: 0 30px 30px;
    .explore {
      display: block;
      font-size: 14px;
      font-weight: 700;
      transition: all 0.5s;
      &::after {
        content: url('../../assets/home/home-right.svg');
        display: inline-block;
        transform: scale(0.8);
        margin-left: 10px;
      }
      &:hover {
        transform: translateX(6px);
        color: #2f5ad9;
      }
    }
  }
}
</style>
